module.exports = __webpack_public_path__ + "/img/c60fcbc877c6f18c6646fc8bd698eca7.png";